import { useEffect } from "react"
import type { TemplateProps } from "./types"
import { BlockRenderer } from "@/components/website-builder/BlockRenderer"
import { FONT_SIZE_MAP } from "@/hooks/useGoogleFont"
import { siteCssVars } from "@/lib/designTokens"

/** Base template that renders sections in order. Applies CSS custom properties from customizations. */
export function BaseTemplate({ org, customizations, sections, isHomePage }: TemplateProps) {
  const sorted = [...sections].sort((a, b) => a.order_index - b.order_index)

  const bodyFont = customizations.body_font || customizations.font_family || "Inter, sans-serif"
  const fontSizeBase = FONT_SIZE_MAP[customizations.font_size ?? "medium"] ?? "16px"

  useEffect(() => {
    document.documentElement.style.scrollBehavior = "smooth"
    return () => {
      document.documentElement.style.scrollBehavior = ""
    }
  }, [])

  return (
    <div
      className="min-h-screen scroll-smooth"
      style={
        {
          ...siteCssVars(customizations),
          fontFamily: bodyFont,
          fontSize: fontSizeBase,
        } as React.CSSProperties
      }
    >
      {sorted.map((section) => (
        <BlockRenderer
          key={section.id}
          section={section}
          customizations={customizations}
          org={org}
          isHomePage={isHomePage}
        />
      ))}
    </div>
  )
}
